// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/async/" + ({"354": "lib-axios","535": "lib-router","783": "lib-react",}[chunkId] || chunkId) + "." + {"116": "0e43a83a","122": "21a578a4","231": "615ad02c","354": "9c6094ad","535": "802f04d8","783": "631bca39","82": "8a583c0f","841": "b4d45025",}[chunkId] + ".js"
}